import PropTypes from 'prop-types';
import React from 'react';

import cx from 'classnames';
import styles from './styles.module.scss';

class PositionView extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(horizontal, vertical) {
    var position = vertical + " " + horizontal;
    if(this.props.onChange){
      this.props.onChange(position)
    }
  }

  render() {
    var horizontalOptions =['left', 'center', 'right'];
    var verticalOptions =['top', 'center', 'bottom'];
    return (
      <div className={styles.positions}>
        {verticalOptions.map(vertical => {
          return horizontalOptions.map(horizontal => {
            var value = `${vertical} ${horizontal}`;
            var active = value === this.props.value;

            return (
              <div className={cx(
                  styles.position, 
                  styles[horizontal], 
                  styles[vertical],
                  {[styles.active]: active}
                )} 
                eventKey={`${horizontal}_${vertical}`}
                onClick={this.handleClick.bind(this, horizontal, vertical)}
              >
                  {!(horizontal === 'center' && vertical === 'center') &&
                  <i className="paperflite-arrow-up"></i>
                }
                {(horizontal === 'center' && vertical === 'center') &&
                  <i>&nbsp;</i>
                }
              </div>    
            );
          })
        })}
      </div>
    );
  }
}

export default PositionView;